import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

export const fetchAllStorefrontSeo = createAsyncThunk('storefrontSeo/fetchAll', async () => {
  const response = await $axios.get('/storefront-seo');
  return response.data?.data || [];
});

export const fetchByPageKey = createAsyncThunk('storefrontSeo/fetchByPageKey', async (pageKey) => {
  const response = await $axios.get(`/storefront-seo/${pageKey}`);
  return response.data?.data;
});

export const updateStorefrontSeo = createAsyncThunk(
  'storefrontSeo/update',
  async ({ pageKey, payload }) => {
    const response = await $axios.patch(`/storefront-seo/${pageKey}`, payload);
    return response.data?.data;
  }
);

const storefrontSeoSlice = createSlice({
  name: 'storefrontSeo',
  initialState: {
    items: [],
    current: null,
    loading: false,
    updating: false,
    error: null,
  },
  reducers: {
    clearCurrent: (state) => {
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllStorefrontSeo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllStorefrontSeo.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload || [];
        state.error = null;
      })
      .addCase(fetchAllStorefrontSeo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
      })
      .addCase(fetchByPageKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchByPageKey.fulfilled, (state, action) => {
        state.loading = false;
        state.current = action.payload;
        state.error = null;
      })
      .addCase(fetchByPageKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
      })
      .addCase(updateStorefrontSeo.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateStorefrontSeo.fulfilled, (state, action) => {
        state.updating = false;
        state.current = action.payload;
        const idx = state.items.findIndex((i) => i.pageKey === action.payload?.pageKey);
        if (idx >= 0) state.items[idx] = action.payload;
        state.error = null;
      })
      .addCase(updateStorefrontSeo.rejected, (state, action) => {
        state.updating = false;
        state.error = action.error?.message;
      });
  },
});

export const { clearCurrent } = storefrontSeoSlice.actions;
export default storefrontSeoSlice.reducer;
